import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ShieldCheck } from "lucide-react";
import { company, services } from "../mock";

const Footer = () => {
  return (
    <footer className="relative mt-24 bg-[#0a2b52] text-white/80 overflow-hidden">
      <div className="aurora bg-[#0066b3] h-72 w-72 -top-20 -left-10" />
      <div className="aurora bg-[#003c7a] h-72 w-72 -bottom-20 right-0" />

      <div className="relative max-w-7xl mx-auto px-6 pt-16 pb-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="h-12 w-12 rounded-xl bg-white flex items-center justify-center p-1.5 shadow-md">
              <img
                src="/assets/favicon-icon.jpg"
                alt="Cloverdale Insurance icon"
                className="h-full w-full object-contain"
              />
            </div>
            <div className="leading-tight">
              <div className="font-display font-extrabold text-lg text-white">
                Cloverdale
              </div>
              <div className="text-[11px] tracking-widest text-[#7db8e6] font-semibold -mt-0.5">
                INSURANCE SERVICES LTD.
              </div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-white/70">
            {company.legalName}. Committed to providing financial security for
            you and your family. Open 7 days a week.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Our Services</h4>
          <ul className="space-y-2.5 text-sm">
            {services.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/${s.slug}`}
                  className="hover:text-[#7db8e6] transition-colors"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Contact Info</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5">
              <MapPin size={17} className="text-[#7db8e6] mt-0.5 shrink-0" />
              <span>{company.address}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone size={17} className="text-[#7db8e6] shrink-0" />
              <a href={`tel:${company.phoneRaw}`} className="hover:text-[#7db8e6]">
                {company.phone}
              </a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail size={17} className="text-[#7db8e6] shrink-0" />
              <a href={`mailto:${company.email}`} className="hover:text-[#7db8e6]">
                {company.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 flex items-center gap-2">
            <Clock size={17} className="text-[#7db8e6]" /> Working Hours
          </h4>
          <ul className="space-y-2.5 text-sm">
            {company.hours.map((h) => (
              <li key={h.day} className="flex flex-col">
                <span className="text-white/90">{h.day}</span>
                <span className="text-[#7db8e6]">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/60">
          <span>
            © {new Date().getFullYear()} {company.legalName}. All rights reserved.
          </span>
          <span>Trusted Insurance Broker in Surrey, BC</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
